import React from "react";
import "./InformationsLegales.css";
import Logo from "./Logo.png";

const InformationsLegales: React.FC = () => {
  return (
    <>
        <div className="barupcontact">
        <h4>Wyn.ma</h4>
    </div>
    <div className="legal-container-cnvi">
      <h2 className="title-cnvi">Informations Légales</h2>

      {/* 🔹 Top Cards */}
      <div className="cards-cnvi">
        <div className="card-cnvi">
          <div className="icon-cnvi">🛡️</div>
          <h3>Politique de Confidentialité</h3>
          <p>
            Découvrez comment nous collectons, utilisons et protégeons vos
            données personnelles conformément à la loi marocaine n°09-08.
          </p>
          <button className="btn-cnvi"><a href="/politique" style={{textDecoration:"none" , color:"white"}}>Consulter la Politique</a></button>
        </div>

        <div className="card-cnvi">
          <div className="icon-cnvi">📄</div>
          <h3>Conditions Générales</h3>
          <p>
            Consultez les règles et conditions d’utilisation du site wyn.ma ainsi
            que nos engagements.
          </p>
          <button className="btn-cnvi"><a href="/politique" style={{textDecoration:"none" , color:"white"}}>Consulter les CGU</a></button>
        </div>
      </div>

      {/* 🔹 Company Info */}
      <div className="company-card-cnvi">
        <h3 className="company-title-cnvi">CHABAKAT AL NAML, SARL</h3>
        <div className="company-info-cnvi">
          <div>
            <h4>Informations Société</h4>
            <p>
              <strong>Registre de commerce :</strong> 602555
            </p>
            <p>
              <strong>CNDP :</strong> D-925/2024
            </p>
            <p>
              <strong>Forme juridique :</strong> SARL
            </p>
          </div>
          <div>
            <h4>Contact</h4>
            <p>📧 contact@wyn.ma</p>
            <p>📞 +212 693-693694</p>
            <p>
              📍 213 Boulevard Anoual
              <br />
              Anoual Capital Center
              <br />
              20250 Casablanca, Maroc
            </p>
          </div>
        </div>
      </div>
    </div>
        <div className="footer-contacte">
        <div>
            <p style={{fontFamily:"lato"}}> Avec plus de 30.000 références en stock, et le rapport le plus détaillé des spécifications de fabrication de tous ses produits, Wyn met à la disposition de ses clients le meilleur service du secteur en pièces et en composants</p>
            <img src={Logo} alt="" />
        </div>
        <div >
            <h3 className="mb-4">pages</h3>
            <h4>Accueille</h4>
            <h4>Voir les articles</h4>
            <h4>Rechercher un articles</h4>
            <h4>Connecter comme visiteur</h4>
            <h4>Politique de confidentialité</h4>

        </div>
        <div>
            <h3 className="mb-4">Contactez Nous sur : </h3>
            <p><i className="bi bi-pin-map-fill"></i>Imm Lotf-Allah Angle Bd La Grande Ceinture et <br />
            Ibn Al Adraa Al Morrakochi Casablanca</p>
            <p><i className="bi bi-whatsapp"></i>+212 693-693694</p>
            <p><i className="bi bi-envelope-paper"></i>Contact@wyn.ma</p>

        </div>
    </div>
    </>
  );
};

export default InformationsLegales;
